module.exports = __webpack_public_path__ + "static/img/invite_job_footer_banner.9e08ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/invite_job_footer_banner.png
// module id = Lnpg
// module chunks = 34